
import React, { Component } from 'react';
import {Route, Switch, Redirect, Link} from 'react-router-dom';
import moment from 'moment';

//import TestPage from "./TestPage";
import Balances from "./Balances";
import AccountBalances from "./AccountBalances";
import Transactions from "./Transactions";
import Accounts from "./Accounts";
import Aging from "./Aging";
import Search from "./Search";
import Payments from "./Payments";

import { QueryService } from 'services/queries';
import ErrorType from 'services/ErrorType';
import config from 'services/config';

import './dashboard.css';
import 'components/FloatingDropdown/styles.css';

import FloatingDropdown from 'components/FloatingDropdown'

class Dashboard extends Component {

  constructor(props) {
    super(props);
    this.state = {
      maxDate: null,
      user: null,
      org: null,
      book: null,
      books: null
    };

    //console.log(this.props)

    if (this.props.location.state && this.props.location.state.user)
      this.state.user = this.props.location.state.user.user

    this.onBookChange = this.onBookChange.bind(this)
    this.getInfo = this.getInfo.bind(this)

    this.queryService = new QueryService()

  }

  async componentWillMount() {
    if (!this.state.maxDate) {
      this.getInfo()
    }
  }

  async getInfo() {

    try {
      let response = await this.queryService.getMaxDate()
      console.log('Info request...', response)
      this.setState({
        maxDate: moment(response.max_date),
        user: response.user,
        org: response.org,
        book: response.book,
        books: response.books
      })
    } catch (err) {
      if (err && err.type) {
        if (err.type === ErrorType.Authorization) {
          this.props.history.push(config.loginPage)
          return
        }
      }
      throw err
    }

  }

  onBookChange(book) {
    //console.log('click!', book)
    if (book) this.queryService.book = book
    //this.setState({book: book})
    this.getInfo(book)
  }

  render() {
    return (
      <div id="wrapper">
      {/* Navbar */}
      <header className="main-header hidden-print"><a className="logo" href="index.html"><img src="/logo/modfin_medium_logo_white.png" alt="Modfin"/></a>
        <nav className="navbar navbar-static-top">
          {/* Sidebar toggle button */}<a className="sidebar-toggle" href="#" data-toggle="offcanvas"></a>
          {/* Navbar Right Menu */}
          <div className="navbar-custom-menu">
            <ul className="top-nav">
              {/* User Menu */}
              <li className="dropdown">
                <a className="dropdown-toggle" href="#" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
                  <i className="fa fa-user fa-lg"></i> &nbsp; {this.state.user ? this.state.user.display_name : 'Profile'}
                </a>
                <ul className="dropdown-menu settings-menu">
                  <li><Link to="/login"><i className="fa fa-sign-out fa-lg"></i> Logout</Link></li>
                </ul>
              </li>
            </ul>
          </div>
        </nav>
      </header>
      {/* Side-Nav */}
      <aside className="main-sidebar hidden-print">
        <section className="sidebar">
          <div className="user-panel">
            <div className="pull-left image">
              <img
                className="img-circle"
                src={this.state.org ? this.state.org.logo_url : ''}
                alt={this.state.org ? this.state.org.display_name : ''}/>
            </div>
            <div className="pull-left info">
              <p>{this.state.org ? this.state.org.display_name : ''}</p>
              
              {this.state.books && (<FloatingDropdown indexName={this.state.book.display_name}
                containerStyle={{left: '53px', top: '104px', textAlign: 'left', fontSize: '13px', paddingLeft: '8px'}}
                toggleStyle={{width: '135px', backgroundColor: '#03B09B', border: 'none', textAlign: 'left', fontWeight: '700'}}
                dropdownStyle={{border: '1px solid #007d6e', backgroundColor: '#03B09B', width: '175px', padding: '0px', textAlign: 'left'}}
                dropdownTopBarStyle={{backgroundColor: '#007d6e', textAlign: 'left', padding: '8px', fontWeight: '700'}}
                toggleAction={(<i className='fa fa-times-circle' />)}
                dropdownContentStyle={{height: '100%', padding: '8px', cursor: 'pointer'}}
                ref={(bookDropdown) => {window.bookDropdown = bookDropdown}}
              >
                {
                  this.state.books.map(b => (
                    <div className='menuItem' key={b.id} onClick={() => {
                      this.onBookChange(b)
                      window.bookDropdown.closeDropdown()
                    }}>
                      <p>{b.display_name}</p>
                    </div>
                  ))
                }
              </FloatingDropdown>)}
            </div>
          </div>
          {/* Sidebar Menu */}
          <ul className="sidebar-menu">
            <li className={this.props.location.pathname == '/dashboard/aging' ? 'active' : ''}>
              <Link to="/dashboard/aging">
                <i className="fa fa-bar-chart-o fa-lg"></i>
                <span>Balances</span>
              </Link>
            </li>
            <li className={this.props.location.pathname == '/dashboard/accounts' ? 'active' : ''}>
              <Link to="/dashboard/accounts">
                <i className="fa fa-th-list fa-lg"></i>
                <span>Contract details</span>
              </Link>
            </li>

            <li className={this.props.location.pathname == '/dashboard/balances' ? 'active' : ''}>
              <Link to="/dashboard/balances">
                <i className="fa fa-hourglass-2 fa-lg"></i>
                <span>Trial balance</span>
              </Link>
            </li>
            <li className={this.props.location.pathname == '/dashboard/transactions' ? 'active' : ''}>
              <Link to="/dashboard/transactions">
                <i className="fa fa-exchange fa-lg"></i>
                <span>Transactions</span>
              </Link>
            </li>
            {/*
            <li className={this.props.location.pathname == '/dashboard/balances/accounts' ? 'active' : ''}>
              <Link to="/dashboard/balances/accounts">
                <i className="fa fa-th-list fa-lg"></i>
                <span>Balances by accounts</span>
              </Link>
            </li>
            <li><a href="/dashboard/testpage"><i className="fa fa-dashboard fa-lg"></i><span>Dashboard</span></a></li>
            <li className="treeview"><a href="#"><i className="fa fa-laptop"></i><span>UI Elements</span><i className="fa fa-angle-right"></i></a>
              <ul className="treeview-menu">
                <li><a href="bootstrap-components.html"><i className="fa fa-circle-o"></i> Bootstrap Elements</a></li>
                <li><a href="https://fontawesome.io/icons/" target="_blank"><i className="fa fa-circle-o"></i> Font Icons</a></li>
                <li><a href="ui-cards.html"><i className="fa fa-circle-o"></i> Cards</a></li>
                <li><a href="widgets.html"><i className="fa fa-circle-o"></i> Widgets</a></li>
              </ul>
            </li>
            <li><a href="charts.html"><i className="fa fa-pie-chart"></i><span>Charts</span></a></li>
            <li className="treeview"><a href="#"><i className="fa fa-edit"></i><span>Forms</span><i className="fa fa-angle-right"></i></a>
              <ul className="treeview-menu">
                <li><a href="form-components.html"><i className="fa fa-circle-o"></i> Form Components</a></li>
                <li><a href="form-custom.html"><i className="fa fa-circle-o"></i> Custom Components</a></li>
                <li><a href="form-samples.html"><i className="fa fa-circle-o"></i> Form Samples</a></li>
                <li><a href="form-notifications.html"><i className="fa fa-circle-o"></i> Form Notifications</a></li>
              </ul>
            </li>
            <li className="treeview"><a href="#"><i className="fa fa-th-list"></i><span>Tables</span><i className="fa fa-angle-right"></i></a>
              <ul className="treeview-menu">
                <li><a href="table-basic.html"><i className="fa fa-circle-o"></i> Basic Tables</a></li>
                <li><a href="table-data-table.html"><i className="fa fa-circle-o"></i> Data Tables</a></li>
              </ul>
            </li>
            <li className="treeview"><a href="#"><i className="fa fa-file-text"></i><span>Pages</span><i className="fa fa-angle-right"></i></a>
              <ul className="treeview-menu">
                <li><a href="blank-page.html"><i className="fa fa-circle-o"></i> Blank Page</a></li>
                <li><a href="page-login.html"><i className="fa fa-circle-o"></i> Login Page</a></li>
                <li><a href="page-lockscreen.html"><i className="fa fa-circle-o"></i> Lockscreen Page</a></li>
                <li><a href="page-user.html"><i className="fa fa-circle-o"></i> User Page</a></li>
                <li><a href="page-invoice.html"><i className="fa fa-circle-o"></i> Invoice Page</a></li>
                <li><a href="page-calendar.html"><i className="fa fa-circle-o"></i> Calendar Page</a></li>
                <li><a href="page-mailbox.html"><i className="fa fa-circle-o"></i> Mailbox</a></li>
                <li><a href="page-error.html"><i className="fa fa-circle-o"></i> Error Page</a></li>
              </ul>
            </li>
            <li className="treeview"><a href="#"><i className="fa fa-share"></i><span>Multilevel Menu</span><i className="fa fa-angle-right"></i></a>
              <ul className="treeview-menu">
                <li><a href="blank-page.html"><i className="fa fa-circle-o"></i> Level One</a></li>
                <li className="treeview"><a href="#"><i className="fa fa-circle-o"></i><span> Level One</span><i className="fa fa-angle-right"></i></a>
                  <ul className="treeview-menu">
                    <li><a href="blank-page.html"><i className="fa fa-circle-o"></i> Level Two</a></li>
                    <li><a href="#"><i className="fa fa-circle-o"></i><span> Level Two</span></a></li>
                  </ul>
                </li>
              </ul>
            </li>*/}
          </ul>
        </section>
      </aside>

      { this.state.maxDate &&
        <Switch>
          <Route path="/dashboard/balances" exact component={(props) =>
            <Balances {...props} maxDate={this.state.maxDate} book={this.state.book} />
          } />
          <Route path="/dashboard/transactions" exact component={(props) =>
            <Transactions {...props} maxDate={this.state.maxDate} book={this.state.book} />
          } />
          <Route path="/dashboard/accounts" exact component={(props) =>
            <Accounts {...props} maxDate={this.state.maxDate} book={this.state.book} />
          } />
          <Route path="/dashboard/aging" exact component={(props) =>
            <Aging {...props} maxDate={this.state.maxDate} book={this.state.book} />
          } />
          <Redirect from="/dashboard" to="/dashboard/aging" />
        </Switch>
      }
      </div>
    )
  }
}

export default Dashboard;

/*
          <li className={this.props.location.pathname == '/dashboard/payments' ? 'active' : ''}>
              <Link to="/dashboard/payments">
                <i className="fa fa-credit-card fa-lg"></i>
                <span>Payments</span>
              </Link>
            </li>
            <li className={this.props.location.pathname == '/dashboard/search' ? 'active' : ''}>
              <Link to="/dashboard/search">
                <i className="fa fa-search fa-lg"></i>
                <span>Search</span>
              </Link>
            </li>
  


<Route path="/dashboard/payments" exact component={(props) =>
            <Payments {...props} maxDate={this.state.maxDate} book={this.state.book} />
          } />
          <Route path="/dashboard/search" exact component={Search} />
*/



// WEBPACK FOOTER //
// ./src/containers/Dashboard/index.js